<template>
  <v-container>
    <v-layout column>
      <v-form>
        <v-flex>
          <AuctionForm @submit="submit" :isDisabledSubmit="isDisabledSubmit" ref="auctionForm" />
          <div class="errors" v-if="errors">
            <div v-for="(error, index) in errors.response.data" :key="index">
              <v-snackbar
                v-model="snackbar"
                :bottom="'bottom'"
                :timeout="6000"
                :vertical="'vertical'"
              >
                {{ error }}
                <v-btn color="pink" text @click="snackbar = false"> Close </v-btn>
              </v-snackbar>
            </div>
          </div>
        </v-flex>
      </v-form>
    </v-layout>
  </v-container>
</template>
<script>
import AuctionForm from '@/components/forms/auctionForm.vue';
import AuctionsService from '@/services/AuctionsService';
import { mapActions } from 'vuex';

export default {
  name: 'auctionCreate',
  data() {
    return {
      snackbar: false,
      errors: false,
      menuTime: false,
      menuDate: false,
      title: '',
      description: '',
      pMTChoices: ['dgfOtherAssets', 'dgfFinancialAssets', 'dgfInsider'],
      datePicker: null,
      timePicker: null,
      itemCount: 1,
      activeItems: 1,
      value: {},
      procurementMethodType: '',
      minimalStep: {},
      itemModels: { 1: {} },
      rules: {
        requiredValue: [(v) => !!v || 'This field is required'],
      },
      isDisabledSubmit: false,
    };
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    submit(routename, data) {
      this.setLoading({ show: true, text: 'Saving...' });
      if (routename === 'auctionCreate') {
        this.isDisabledSubmit = true;
        AuctionsService.createAuction(data).then(
          (response) => {
            this.errors = false;
            this.isDisabledSubmit = false;
            this.$router.push({
              path: '/auctions/' + response.data.id,
            });
            this.setLoading({ show: false, text: '' });
          },
          (err) => {
            if (err.response.data.hasOwnProperty('auctionPeriod')) {
              this.showSnackbar(err.response.data.auctionPeriod.startDate[0].split('.')[0]);
            } else {
              this.showSnackbar(err.response.data);
            }
            this.snackbar = true;
            this.isDisabledSubmit = false;
            this.setLoading({ show: false, text: '' });
          }
        );
      }
    },
  },
  components: {
    AuctionForm,
  },
};
</script>
<style>
.errors {
  color: firebrick;
  margin-top: 40px;
}
.submit-button-container {
  margin-top: 30px;
}
</style>
